import { useAuth } from '@/lib/auth/auth';
import type { OrganizationInvitationSummary } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const organizationInvitationKeys = {
  all: ['organization-invitations'] as const,
  list: (organizationID: string) => [...organizationInvitationKeys.all, organizationID] as const,
};

export function useOrganizationInvitations(organizationID: string, enabled = true) {
  const session = useAuth((state) => state.session);
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: organizationInvitationKeys.list(organizationID),
    enabled: Boolean(session) && enabled && organizationID.length > 0,
    queryFn: () => request<OrganizationInvitationSummary[]>(`/organizations/${organizationID}/invitations`),
  });
}
